import { render, staticRenderFns } from "./ProcessTaskDetails.vue?vue&type=template&id=7284a3a3&scoped=true"
import script from "./ProcessTaskDetails.vue?vue&type=script&lang=js"
export * from "./ProcessTaskDetails.vue?vue&type=script&lang=js"
import style0 from "./ProcessTaskDetails.vue?vue&type=style&index=0&id=7284a3a3&prod&scoped=true&lang=css"
import style1 from "./ProcessTaskDetails.vue?vue&type=style&index=1&id=7284a3a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284a3a3",
  null
  
)

export default component.exports